import {Branch} from "../../model/Branch";
import * as angular from "angular";
import {IController, IHttpResponse, IScope} from "angular";
import {BranchUsers} from "../../model/BranchUsers";
import {UserServiceName} from "../../../utils/names/serviceNames";
import {UserService} from "../../../users_service/service/user.service";
import './branch-users.dialog.component.scss';
import {getDefaultAvatarUrl} from "../../../users/model/User";

interface BranchUsersDialogComponentScope extends IScope {
    closeWindow: () => void;
    branch: Branch;
    branchUsers: BranchUsers[];
    showLoader: boolean;
}

export class BranchUsersDialogComponent implements IController {

    public static instance =
        ($event: MouseEvent, branch: Branch): angular.material.IDialogOptions => ({
            parent: angular.element(document.body),
            template: require('./branch-users.dialog.component.html'),
            controller: ['$scope', 'branch', '$mdDialog', UserServiceName, BranchUsersDialogComponent],
            targetEvent: $event,
            clickOutsideToClose: true,
            locals: {
                branch: branch
            },
        });

    private $scope: BranchUsersDialogComponentScope;
    private userService: UserService;
    private $mdDialog: angular.material.IDialogService;


    constructor($scope: BranchUsersDialogComponentScope,
                branch: Branch,
                $mdDialog: angular.material.IDialogService,
                userService: UserService) {
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.$scope.branch = branch;
        this.userService = userService;
        $scope.closeWindow = this.closeWindow;
        this.fetchUsers(branch);
    }

    closeWindow = () => {
        this.$mdDialog.cancel();
    };

    private fetchUsers(branch: Branch) {
        this.$scope.showLoader = true;
        this.userService.getActiveUsersOfTheBranch(branch)
            .then(resp => {
                if (resp.status === 200) {
                    this.assignAvatarUrl(resp);
                    this.$scope.branchUsers = resp.data;
                    this.$scope.showLoader = false;
                }
            });
    }

    private assignAvatarUrl(resp: IHttpResponse<BranchUsers[]>) {
        resp.data.forEach(user => {
            if (!user.avatarUrl) {
                user.avatarUrl = getDefaultAvatarUrl(user.gender);
            }
        });
    }
}